import {SCREEN_NUMBER,LANGUAGE,SCORE,PLAYTIME,RANDAMIZE,SETMYTHSANDFACTS,SETCURRENTINDEX,SETCURRENTQUESTION,SETSHOWCORRECTWRONG} from '../actions/typs';
import  * as initialStateConfig from "../../src/gameState.json";

const initialState = {
    language:initialStateConfig.language,
    screenNumber:initialStateConfig.screenNumber,
    oldScreenNumber:initialStateConfig.oldScreenNumber,
    playTime:initialStateConfig.playTime,
    score:initialStateConfig.score,
    israndamized:initialStateConfig.israndamized,
    currentIndex:initialStateConfig.currentIndex,
    currentQuestion:initialStateConfig.currentQuestion,
    showCorrectWrong:initialStateConfig.showCorrectWrong
}
export default function(state = initialState,action){
switch(action.type){
    case LANGUAGE:
        return{
            ...state,
            language:action.language
        };
    case SCREEN_NUMBER:
        return{
            ...state,
            screenNumber:action.screenNumber,
            oldScreenNumber:action.oldScreenNumber
        }; 
    case SCORE:
        return{
            ...state,
            score:action.score
        }; 
    case PLAYTIME:
        return{
            ...state,
            playTime:action.playTime
        };
       case RANDAMIZE:
        return{
            ...state,
            israndamized:action.israndamized
        };  
       case SETMYTHSANDFACTS:
        return{
            ...state,
            mythsAndFacts:action.randMythsAndFacts
        };  
        case SETCURRENTINDEX:
        return{
            ...state,
            currentIndex:action.currentIndex
        }; 
        case SETCURRENTQUESTION:
        return{
            ...state,
            currentQuestion:action.currentQuestion
        }; 
         case SETSHOWCORRECTWRONG:
        return{
            ...state,
            showCorrectWrong:action.showCorrectWrong
        };        
    default:
        return state;
}
}


// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js